import React, { Component } from 'react'
import PropTypes from 'prop-types'
import I18n, { Translate } from 'i18n'
import Loader from 'components/Loader'
import AppCaptcha from 'components/AppCaptcha'
import './style.css'


export default class FormEmailFooter extends Component {
    static propTypes = {
        fetchSendEmailShoppingList: PropTypes.func.isRequired,
        setEmailAddress: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
        emailAddress: PropTypes.string.isRequired,
        errorMessage: PropTypes.string.isRequired,
        isLoading: PropTypes.bool.isRequired,
        status: PropTypes.string.isRequired,
        isCaptchaPassed: PropTypes.bool.isRequired
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.status === 'loading' && nextProps.status === 'submitted') {
            this.props.onSubmit()
        }
    }

    handleSubmit = (e) => {
        e.preventDefault()
        this.props.fetchSendEmailShoppingList()
    }

    handleChange = (e) => {
        this.props.setEmailAddress(e.target.value)
    }

    onCancelClickHandler = () => {
        this.props.onCancel()
    }

    render() {
        if (this.props.isLoading) {
            return <Loader />
        }

        return (
            <div className='form-email-footer'>
                <div className='form-email-wrapper'>
                    <div className='input-wrapper'>
                        <input
                            className='form__input form__input_email'
                            type='email'
                            name='email'
                            value={this.props.emailAddress}
                            placeholder={I18n.t('email')}
                            onChange={this.handleChange}
                        />
                    </div>
                    { !this.props.isCaptchaPassed &&
                        <AppCaptcha />
                    }
                    <button
                        onClick={this.onCancelClickHandler}
                        className='button button_type_secondary button_type_emailCancel'>
                        <span className='icon'></span>
                        <Translate value='cancel' />
                    </button>
                    { this.props.isCaptchaPassed &&
                        <button
                            className={`button button_type_alert button_icon_${!this.props.isEmailSent || this.props.isDisabled ? 'send' : 'check'} ${this.props.isDisabled || this.props.isEmailSent ? 'button_type_disabled' : ''}`}
                            type='submit'
                            onClick={this.handleSubmit}>

                            <span className={`icon icon-${!this.props.isEmailSent || this.props.isDisabled ? 'send' : 'check'}`} />

                            { !this.props.isEmailSent || this.props.isDisabled
                                ? <Translate value='emailMeTheList' />
                                : <Translate value='emailSent' />
                            }
                        </button>
                    }
                </div>


                { this.props.errorMessage &&
                    <p className='form-text form-text_type_error'>{this.props.errorMessage}</p>
                }
            </div>
        )
    }
}
